<template lang="pug">
v-container(fluid fill-height class=" tw-content-start")
  v-row(dense class="tw-mb-1 ")
    v-col(class="")
      kubiqa-files-add-list-item(@fileAdded="init")
  template(v-if="!loading && !loadFailed && files.length > 0")
    v-row(no-gutters class="tw-bg-gray-lighten-4 tw-bg-opacity-50  tw-py-3 tw--mx-8")
      v-spacer
      v-col(cols="7")
        span(class="tw-text-sm tw-font-medium tw-text-blueGray-base tw-pl-8") {{ $t('Opportunities.Common.fileName') }}
      v-spacer
      v-col(cols="2" class="tw-text-right")
        span(class="tw-text-sm tw-font-medium tw-text-blueGray-base tw-pl-6") {{ $t('Opportunities.Common.modified') }}
      v-spacer
      v-col(cols="2")

    v-row(dense class=" tw-max-h-main tw-overflow-y-scroll")
      v-col(class=" tw-overflow-y-scroll")
        div(v-for="(file, index) in files" :key="file.id" class="tw-py-1")
          kubiqa-files-list-item(:item="file" @removedItem="init")
          div(v-if="index == 40 - 1" class="tw-pb-48")
  template(v-else-if="!loading && !loadFailed")
    v-row(dense justify="center" align="center" class="tw-h-full tw-overflow-y-scroll ")
      v-col(cols="auto")
        kubiqa-misc-empty-state(
          :title="$t('Common.emptyStates.filesTitle')"
          :description="$t('Common.emptyStates.filesBody')"
          :illustration="require('@/assets/images/illustrations/empty-files.svg')"
        )
  template(v-else)
    v-row(dense justify="center" align="center" class="tw-h-full")
      v-col(cols="auto")
        kubiqa-misc-empty-state(
          :title="$t('Common.emptyStates.loadErrorTitle')"
          :description="$t('Common.emptyStates.loadErrorBody')"
          :action-label="$t('Common.emptyStates.retry')"
          icon="mdi-alert-circle-outline"
          @action="init"
        )
</template>
<script>
export default {
  data() {
    return { key: 1, loading: true, loadFailed: false };
  },
  computed: {
    opportunity() {
      return this.$route.params.id;
    },
    files: {
      get() {
        return this.$store.getters['opportunities/files/list'];
      },
      set(files) {
        this.key++;
        this.$store.dispatch('opportunities/files/updateFileList', files);
      },
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
    this.loading = true;
      try {
        const result = await this.$store.dispatch('opportunities/files/list', this.opportunity);
        this.key++;
        this.loadFailed = !Array.isArray(result);
      } finally {
      this.loading = false;
      }
    },
  },
};
</script>
